import React from "react";
import { useTranslation } from "react-i18next";

import ModalContainer from "../../../../components/ModalContainer";
import Button from "../../../../components/Button";

const RemoveImg = (props) => {
  const { t } = useTranslation();
  const {
    isRemoveImgModal,
    setRemoveImgModal,
    MyProfileStoreCtrl
  } = props;

  return (
    <ModalContainer
      modalWidthType='modal-500px'
      openModal={isRemoveImgModal}
      closeModal={() => setRemoveImgModal(false)}
    >
      <div className='header'>
        <div className='title'>{t('fc35ec973f')}</div>
      </div>
      <div className='body'>
        <div>{t('f26a7bc211')}</div>
      </div>
      <div className='footer'>
        <Button
          label={t('ea4788705e')}
          className='btn-cancel'
          onClick={() => setRemoveImgModal(false)}
        />
        <Button
          label={t('f2a6c498fb')}
          className='btn-delete'
          onClick={() => MyProfileStoreCtrl.deleteImage()}
        />
      </div>
    </ModalContainer>
  )
}

export default React.memo(RemoveImg);